import React from 'react';
import { Typography } from '@material-ui/core';

function TermsAndConditions() {
  return (
    <>
      <Typography variant="h3" gutterBottom align="center">
        Terms & conditions
      </Typography>
      <Typography variant="body1" gutterBottom>
        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
        industry&apos;s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and
        scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into
        electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of
        Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus
        PageMaker including versions of Lorem Ipsum.
      </Typography>
      <Typography variant="body1" gutterBottom>
        Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin
        literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney
        College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and
        going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum
        comes from sections 1.10.32 and 1.10.33 of &lsquo;de Finibus Bonorum et Malorum&lsquo; (The Extremes of Good and
        Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the
        Renaissance. The first line of Lorem Ipsum, &lsquo;Lorem ipsum dolor sit amet..&lsquo;, comes from a line in
        section 1.10.32.
      </Typography>
      <Typography variant="body1" gutterBottom>
        The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections
        1.10.32 and 1.10.33 from &lsquo;de Finibus Bonorum et Malorum&lsquo; by Cicero are also reproduced in their
        exact original form, accompanied by English versions from the 1914 translation by H. Rackham.
      </Typography>
      <Typography variant="body1" gutterBottom>
        It is a long established fact that a reader will be distracted by the readable content of a page when looking at
        its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as
        opposed to using &lsquo;Content here, content here&lsquo;, making it look like readable English. Many desktop
        publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for
        &lsquo;lorem ipsum&lsquo; will uncover many web sites still in their infancy. Various versions have evolved over
        the years, sometimes by accident, sometimes on purpose (injected humour and the like).
      </Typography>
      <Typography variant="body1" gutterBottom>
        There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in
        some form, by injected humour, or randomised words which don&apos;t look even slightly believable. If you are
        going to use a passage of Lorem Ipsum, you need to be sure there isn&apos;t anything embarrassing hidden in the
        middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary,
        making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined
        with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem
        Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.
      </Typography>
    </>
  );
}

export default TermsAndConditions;
